import * as Yup from 'yup';

export const airtableConnectorSchema = {
  connectorName: '',
  authorization: '',
};

export const airtableConnectorSchemaValidation = Yup.object().shape({
  connectorName: Yup.string()
    .required('Connector Name is required')
    .max(100, 'Name can not be more than 100 characters'),
  authorization: Yup.string().required('Authorization is required'),
});
